<template>
  <hp5-filter-panel
    :element-id="elementId"
    :expanded="expand"
    :filter-panel-label="label"
    label-tag-selection="h3"
  >
    <slot></slot>
  </hp5-filter-panel>
</template>

<script setup>

    const props = defineProps({
        elementId: String,
        label: String,
        tag: {
            type: String,
            default: 'h3'
        },
        expand: {
            type: Boolean,
            default: false
        }
    })

</script>

<style lang="scss">

    hp5-filter-panel {
        h1,h2,h3 {
            margin-top: 0px;
            margin-bottom: 0px;
        }

        .filter-panel-button {
            padding: var(--spacing-xxs) var(--spacing-xs) !important;
        }
    }

</style>